import { Component, Type } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { PickerType } from '@danielmoncada/angular-datetime-picker';
import {
  FieldType,
  FieldTypeConfig,
  FormlyFieldConfig,
  FormlyFieldProps,
  FormlyModule,
} from '@ngx-formly/core';
import { DateTime, Duration } from 'luxon';
import { DatetimePickerComponent } from './datetime-picker.component';

interface DatetimePickerProps extends FormlyFieldProps {
  allowPastDates?: boolean;
  minDate?: string;
  minDateRelative?: string;
  maxDate?: string;
  maxDateRelative?: string;
  defaultTime?: string;
  pickerType?: PickerType;
}

export interface FormlyDatetimePickerFieldConfig extends FormlyFieldConfig<DatetimePickerProps> {
  type: 'datetime-picker' | Type<FormlyDatetimePickerComponent>;
}

@Component({
  imports: [DatetimePickerComponent, ReactiveFormsModule, FormlyModule],
  selector: 'vectronic-formly-datetime-picker-wrapper',
  template: `
    <vectronic-formly-datetime-picker
      [formControl]="formControl"
      [id]="id"
      [name]="field.name"
      [formlyAttributes]="field"
      [tabIndex]="props.tabindex"
      [min]="minDate"
      [max]="maxDate"
      [label]="field.props?.label"
      [pickerType]="field.props?.pickerType"
      [required]="field.props?.required"
      [defaultTime]="props?.defaultTime ?? '00:00'"
      [invalid]="showError && formControl.hasError('required')"
    >
      <formly-validation-message [field]="field"></formly-validation-message>
    </vectronic-formly-datetime-picker>
  `,
})
export class FormlyDatetimePickerComponent extends FieldType<FieldTypeConfig<DatetimePickerProps>> {
  get minDate() {
    if (this.props?.allowPastDates === false) {
      return DateTime.now().toUTC().set({ hour: 0, minute: 0, second: 0, millisecond: 0 }).toISO();
    }
    if (this.props?.minDate != null) {
      return this.props.minDate;
    }
    if (this.props?.minDateRelative != null) {
      return DateTime.now()
        .toUTC()
        .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
        .plus(Duration.fromISO(this.props.minDateRelative))
        .toISO();
    }
    return undefined;
  }

  get maxDate() {
    if (this.props?.maxDate != null) {
      return this.props.maxDate;
    }
    if (this.props?.maxDateRelative != null) {
      return DateTime.now()
        .toUTC()
        .set({ hour: 0, minute: 0, second: 0, millisecond: 0 })
        .plus(Duration.fromISO(this.props.maxDateRelative))
        .toISO();
    }
    return undefined;
  }
}
